export enum PRICE_STATUS {
  OWNER = 'OWNER',
  USER = 'USER',
}
